import { axiosInstanceDefault, axiosInstanceAttendanceAPI } from './axios';
// import {handleErrors} from '@/lib/errorhandler';

const getAxiosInstance = (api) => api === 'attendance-api' ? axiosInstanceAttendanceAPI
  : axiosInstanceDefault;

export async function getRequest(url, queryParams, api = 'default') {

  const axios = getAxiosInstance(api);

  try {
    return (await axios.get(url, { params: queryParams })).data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function getRequestWithMoreOptions(url, options, api = 'default') {

  const axios = getAxiosInstance(api);

  try {
    return (await axios.get(url, { ...options })).data;
  } catch (e) {
    return Promise.reject(e);
  }
}

export async function postRequest(url, requestBody, options = {}, api = 'default') {

  const axios = getAxiosInstance(api);

  try {

    return (await axios.post(url, requestBody, { ...options })).data;
  } catch (e) {
    console.log('postRequest ERR', e);
    return Promise.reject(e);
  }
}
export async function putRequest(url, requestBody, options = {}, api = 'default') {

  const axios = api === 'attendance-api' ? axiosInstanceAttendanceAPI
    : axiosInstanceDefault;

  console.log('api', api)

  try {
    return (await axios.put(url, requestBody, { ...options })).data;
  } catch (e) {
    console.log('putRequest ERR', e);
    return Promise.reject(e);
  }
}

export async function patchRequest(url, requestBody, api = 'default') {

  const axios = getAxiosInstance(api);

  try {

    return (await axios.patch(url, requestBody)).data;
  } catch (e) {
    console.log('patchRequest ERR', e);
    return Promise.reject(e);
  }
}

export async function deleteRequest(url, api = 'default') {

  const axios = getAxiosInstance(api);

  try {

    return (await axios.delete(url)).data;
  } catch (e) {
    console.log('deleteRequest ERR', e);
    return Promise.reject(e);
  }
}

export async function postMultipart(url, formData, api = 'default') {

  const axios = getAxiosInstance(api);

  try {

    return (await axios.post(url, formData, /* {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } */)).data;
  } catch (e) {
    console.log('postMultipart ERR', e);
    return Promise.reject(e);
  }
}


/* 

// //axios with swr (direct)
  // const fetcher = url => client.get(url).then(res => res.data)
  // const { data: posts, error, mutate } = useSWR('<URL>', fetcher)
  // //axios with swr


  //Method Based axios-swr
  const axiosInstance = axios.create({
    // baseURL: "https://jsonplaceholder.typicode.com/posts"  // ?_limit=10
    baseURL: "https://5c50zogd68.execute-api.ap-southeast-1.amazonaws.com/v1/" // x-1231123/ticket
  });
  
  function getAxiosInstance() {
    return axiosInstance
  }

  async function getRequest(url) {
    try {
      const axios = getAxiosInstance();
      return (await axios.get(url)).data
    } catch (e) {
      console.log('getRequest Error', e)
      return Promise.reject(e)
    }
  }
  
  const FetchData = () => {
    const { data: ticket, error: ticketErr, mutate: ticketMutate } = useSWR('x-1231123/ticket', getRequest)
    return {ticket, ticketErr, ticketMutate}
  }
  
  const {ticket, ticketErr, ticketMutate} = FetchData()
  //Method Based fetcher
*/